import { Box, useColorModeValue } from '@chakra-ui/react';
import EpisodeCard from 'components/card/EpisodeCard';
import EpisodeCreateModal from 'components/layouts/patients/EpisodeCreateModal';
import { useState } from 'react';
import { ClinicalEpisode, EstadoEpisodio } from 'types/models';

function mockEpisode(overrides: Partial<ClinicalEpisode> = {}): ClinicalEpisode {
  return {
    id:                     'ep-preview-1',
    tarjeteroId:            'tarj-1',
    codigoHc:               'HC-2024-001',
    pacienteId:             'pac-1',
    profesionalId:          'prof-1',
    estado:                 EstadoEpisodio.ABIERTO,
    motivoConsulta:         'Dolor lumbar de 3 semanas de evolución, intensidad EVA 7/10 en reposo.',
    fechaApertura:          '2024-11-15',
    fechaCierre:            null,
    diagnosticoPrincipal:   null,
    diagnosticoSecundario:  null,
    codigoCie10:            null,
    notaApertura:           null,
    notaCierre:             null,
    anamnesis:              null,
    diagnosticoDiferencial: null,
    pruebasSolicitadas:     null,
    ...overrides,
  } as ClinicalEpisode;
}

const EP_ABIERTO = mockEpisode({
  estado:       EstadoEpisodio.ABIERTO,
  codigoHc:     'HC-2024-001',
  notaApertura: 'Paciente refiere inicio tras esfuerzo físico en trabajo. Sin irradiación. Antecedentes: HTA controlada.',
});

export default function EpisodeCardPreview() {
  const bg = useColorModeValue('gray.50', 'gray.900');

  const cb = (name: string) => (...args: any[]) => console.log(name, ...args);

  const [completeModal, setCompleteModal] = useState<{ episode: ClinicalEpisode; step: number } | null>(null);

  return (
    <Box minH='100vh' bg={bg} px={{ base: '24px', lg: '64px' }} py='56px'>
      <EpisodeCard
        episode={EP_ABIERTO}
        onDiagnoseClick={cb('onDiagnoseClick')}
        onEditClick={cb('onEditClick')}
        onStartTreatmentClick={cb('onStartTreatmentClick')}
        onCloseClick={cb('onCloseClick')}
        onCompleteAtStep={(step) => setCompleteModal({ episode: EP_ABIERTO, step })}
        w='100%'
      />

      {completeModal && (
        <EpisodeCreateModal
          isOpen
          onClose={() => setCompleteModal(null)}
          patientId={completeModal.episode.pacienteId}
        />
      )}
    </Box>
  );
}
